

























































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { HorariosDisponiveisDTO } from "@/api/cadastro/saude/HorariosDisponiveisDTO";

@Component
export default class DetalheAgendamentos extends Vue {
  @Prop({ required: true, default: [] })
  horariosDisponiveis!: HorariosDisponiveisDTO[];

  parseStatus(status: string): string {
    if (status == "DISPONIVEL") return "Disponível";
    else if (status == "AGENDADO") return "Agendado";
    else if (status == "BLOQUEADO") return "Bloqueado";
    else if (status == "FERIADO") return "Feriado";
    return "";
  }

  @Emit("bloquear")
  bloquearHorario(horario: HorariosDisponiveisDTO) {
    return horario;
  }

  @Emit("desbloquear")
  desbloquearHorario(horario: HorariosDisponiveisDTO) {
    return horario;
  }

}
